import React from "react";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";

interface ImageAsset {
  asset?: {
    _id?: string;
  };
  alt?: string;
}

interface ImageProps {
  node?: ImageAsset;
  nodeM?: ImageAsset;
  alt?: string;
  loading?: "eager" | "lazy";
}

const Image: React.FC<ImageProps> = ({ node, nodeM, alt, loading }) => {
  if (!node || !node.asset) {
    return null;
  }

  const altVal = alt || node.alt || "";
  const loadingVal = loading || "lazy";

  return (
    <>
      {nodeM?.asset ? (
        <picture>
          <source media="(min-width:960px)" srcSet={imageUrlFor(buildImageObj(node)).auto("format").url()} />
          <source media="(max-width:959px)" srcSet={imageUrlFor(buildImageObj(nodeM)).auto("format").url()} />
          <img src={imageUrlFor(buildImageObj(node)).auto("format").url()} alt={altVal} loading={loadingVal} />
        </picture>
      ) : (
        <img src={imageUrlFor(buildImageObj(node)).auto("format").url()} alt={altVal} loading={loadingVal} />
      )}
    </>
  );
}

export default Image;
